var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPriceicon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.996,
    height: 16,
    viewBox: "0 0 15.996 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "icons8_price_tag",
    d: "M13.606,4a2.4,2.4,0,0,0-1.7.7l-7.2,7.2a2.409,2.409,0,0,0,0,3.394l4,4a2.4,2.4,0,0,0,3.394,0l7.2-7.2a2.4,2.4,0,0,0,.7-1.7V6a2.009,2.009,0,0,0-2-2Zm0,1.2h4.4a.794.794,0,0,1,.8.8v4.4a1.179,1.179,0,0,1-.352.849l-7.2,7.2a1.2,1.2,0,0,1-1.7,0l-4-4a1.194,1.194,0,0,1,0-1.7l7.2-7.2A1.177,1.177,0,0,1,13.606,5.2Zm2.4,1.6a1.2,1.2,0,1,0,1.2,1.2A1.2,1.2,0,0,0,16.006,6.8Z",
    transform: "translate(-4.01 -4)",
    fill: "#070707"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPriceicon);
export default __webpack_public_path__ + "static/media/priceicon.52453cd229fb355bea2353efbdc82a43.svg";
export { ForwardRef as ReactComponent };